module.exports = __webpack_public_path__ + "atlasOnboardingLogo.bb3aee0fbb08aa7299c276db4429f5c9.png";